module.exports = __webpack_public_path__ + "img/icon-pinterest.5e4a8b34.svg";